
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-4"></div>
        <div class="col-lg-4">
            <img src="assets/img/auri.png" width="100%">
            <input [(ngModel)]="input.username" class="form-control" placeholder="Celular o correo electronico" ><br>
            <input [(ngModel)]="input.password" class="form-control" type="password" placeholder="Password"><br>
            <button (click)="onLogin()" class="btn btn-success form-control fondoNaranja inputInicioSesion">Iniciar Sesión</button>
            <br><br>
            <div *ngIf="error == 1">
                <div class="alert alert-danger" role="alert">
                    No hemos podido iniciar sesión con las credenciales proporcionadas.
                  </div>
            </div>
        </div>
        <div class="col-lg-4"></div>
    </div>
</div>

